"use client";
import cls from './not-found.module.css';
import { Button } from '@/components/UI/Button/Button';
import { ImageCarousel } from '@/components/UI/ImageCarousel/ImageCarousel';
import { useRouter } from 'next/navigation';
import Conveyor from "@/public/not-found/сonveyor.webp"
import Boxes from "@/public/not-found/boxed.svg"
import { useMemo } from 'react';

import Computer from "@/public/not-found/computer.webp"
import Tablet from "@/public/not-found/tablet.webp"
import Mobile from "@/public/not-found/mobile.webp"

import BlackBox from "@/public/not-found/black-box.png"
import Crane from "@/public/not-found/crane.webp"
import Line from "@/public/not-found/line.png"
import CraneItems from "@/public/not-found/crane-items.webp"
import Image from "next/image";
import { usePathname } from 'next/navigation';
import { getBlogPagePath, getContactsPagePath, getProjectsPagePath, getServicesPagePath, getTeamPagePath, } from '@/utils/consts';

export default function NotFound() {
    const router = useRouter();
    const pathname = usePathname();
    const handleGoBack = () => {
        router.back();
    }

    const islinksUnderConstruction = [
        getTeamPagePath(),
        getProjectsPagePath(),
        getServicesPagePath(),
    ]

    const isUnderConstruction = islinksUnderConstruction.includes(pathname);

    const MIN_SLIDES_FOR_SMOOTH = 4;
    const duplicatedImages = useMemo(() => {
        return Array(MIN_SLIDES_FOR_SMOOTH).fill(Boxes);
    }, []);
    const duplicatedImages2 = useMemo(() => {
        return Array(MIN_SLIDES_FOR_SMOOTH).fill(Conveyor);
    }, []);
    return (
        <div className={cls.container}>
            <div className={cls.content}>
                <h1 className={cls.title}>{isUnderConstruction ? "In progress!" : "Error 404!"}</h1>
                <p className={cls.subtitle}>Oops... This page is still under construction. You may want to try another one.</p>
                <Button onClick={handleGoBack} className={cls.btnBack}>Go back</Button>
            </div>
            <div className={cls.imagesContainer}>
                <img src={Computer.src} alt="Computer" className={cls.computerImage} />
                <img src={Tablet.src} alt="Tablet" className={cls.tabletImage} />
                <img src={Mobile.src} alt="Mobile" className={cls.mobileImage} />
                <div className={cls.bottomImages}>
                    <img src={BlackBox.src} alt="Black Box" className={cls.blackBoxImage} />
                    <div className={cls.carousels}>
                        <ImageCarousel speed={1} duplicatedImages={duplicatedImages} className="" direction="left" />
                        <ImageCarousel speed={1} duplicatedImages={duplicatedImages2} className={cls.conveyour} direction="right" />
                    </div>
                </div>
            </div>
            <div className={cls.craneContainer}>
                <div className={cls.craneLineWithItem}>
                    <img src={Line.src} alt="Line" className={cls.lineImage} />
                    <img src={CraneItems.src} alt="Crane Items" className={cls.craneItemsImage} />
                </div>
                <img src={Crane.src} alt="Crane" className={cls.craneImage} />
            </div>
        </div>
    );
}